import request from '@/utils/request'
let OrderApi = {
  /*提现列表*/
  withdrawalList(data, errorback) {
    return request._postBody('/front/user/yxshopUserWithdrawalRecords/index', data, errorback);
  },

  /*提现详情*/
  withdrawalDetail(data, errorback) {
    return request._postBody('/front/user/yxshopUserWithdrawalRecords/detail', data, errorback);
  },

  /*提交审核*/
  onSubmit(data, errorback) {
    return request._postBody('/front/user/yxshopUserWithdrawalRecords/onSubmit', data, errorback);
  },
  /*发送验证码*/
  getCode(data, errorback) {
    return request._get('/shop/setting/withdrawVerify/getCode', data, errorback);
  },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/withdrawal.js